import React from "react";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiCalendarBlankOutline, mdiOpenInNew } from "@mdi/js";
import CardShell from "./CardShell";
import BookingNote from "./BookingNote";
import {
  formatDateLong,
  formatTimeRange,
} from "app/containers/Jobs/utils/dateFormat";

const JobBookingCard = ({ job, onEdit }) => {
  const { client, agent, property } = job;

  const propertyParts = [
    property?.year_built && `${property.year_built} built`,
    property?.square_feet && `${property.square_feet} sqft`,
    property?.stories && `${property.stories} stories`,
    property?.house_type,
    property?.parcel_number && `Parcel ${property.parcel_number}`,
  ].filter(Boolean);

  return (
    <CardShell
      icon={
        <Icon
          path={mdiCalendarBlankOutline}
          size={0.7}
          className="jd-card-icon"
        />
      }
      title="Job Booking"
      headerRight={
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={onEdit}
          // The modal saves by appointment id. Without one there is no row to
          // PUT, so offering Edit would only ever produce a 404 toast.
          disabled={!job.appointment_id}
        >
          Edit
        </Button>
      }
    >
      <div className="jd-booking-grid">
        <div>
          <div className="jd-label">Date &amp; Time</div>
          <div className="jd-value-strong">{formatDateLong(job.date)}</div>
          <div className="jd-contact">
            {formatTimeRange(job.start_time, job.end_time)}
          </div>
          <BookingNote note={job.note} />
        </div>

        <div>
          <div className="jd-label">Client</div>
          {client?.name ? (
            <>
              <div className="jd-value-strong">{client.name}</div>
              {client.phone && <div className="jd-contact">{client.phone}</div>}
              {client.email && <div className="jd-link">{client.email}</div>}
              <BookingNote note={client.note} />
            </>
          ) : (
            <span className="jd-empty">N/A</span>
          )}
        </div>

        <div>
          <div className="jd-label">Agent</div>
          {agent?.name ? (
            <>
              <div className="jd-value-strong">
                {agent.name}
                {agent.id && (
                  <Icon
                    path={mdiOpenInNew}
                    size={0.55}
                    className="jd-agent-link"
                    onClick={() =>
                      window.open(
                        `/agent-management/${agent.id}/edit`,
                        "_blank"
                      )
                    }
                  />
                )}
              </div>
              {agent.phone && <div className="jd-contact">{agent.phone}</div>}
              {agent.email && <div className="jd-link">{agent.email}</div>}
              {agent.role && <div className="jd-contact">{agent.role}</div>}
              {agent.agency && <div className="jd-contact">{agent.agency}</div>}
            </>
          ) : (
            <span className="jd-empty">N/A</span>
          )}
        </div>
      </div>

      {propertyParts.length > 0 && (
        <div className="jd-property-row">
          <span className="jd-label">Property Details</span>
          <span className="jd-property-value">{propertyParts.join(" · ")}</span>
          <BookingNote note={property?.note} inline />
        </div>
      )}
    </CardShell>
  );
};

export default JobBookingCard;
